import CountyLandingPage from "../components/CountyLandingPage";

const data = {
  slug: "bay-area",
  region: "Bay Area",
  metaTitle: "Bay Area ADU Permit Toolkit",
  h1Prefix: "Bay Area ADU permits,",
  h1Accent: "without the back-and-forth.",
  subtitle:
    "Pre-built for the Bay Area's nine counties — San Francisco, Alameda, Contra Costa, Marin, San Mateo, Santa Clara, Solano, Sonoma, and Napa. CALGreen waste plan, Title 24 notes, and an AI cover memo referencing the right local portal for each jurisdiction.",
  heroStats: [
    { value: "+82%", label: "ADU approvals in SF after streamlined review" },
    { value: "9", label: "Bay Area counties supported" },
    { value: "10 min", label: "wizard to permit-ready package" },
  ],
  localRules: [
    {
      title: "San Francisco DBI online submittal portal",
      body: "SF Department of Building Inspection requires online submittal with a CALGreen worksheet and a CWMP. The AI memo addresses DBI specifically when the city is San Francisco.",
    },
    {
      title: "Alameda + Contra Costa stricter local diversion targets",
      body: "Some East Bay cities require 75% or 80% diversion — stricter than CALGreen's 65%. Our wizard flags this and adjusts the diversion math automatically.",
    },
    {
      title: "Marin County green-building amendment",
      body: "Marin's local CALGreen amendment adds embodied-carbon notes for new construction over a threshold. Our Title 24 cover paragraph references the amendment when applicable.",
    },
    {
      title: "Santa Clara County recycling infrastructure",
      body: "Strong concrete + metals recycling but limited drywall routes. The plan is calibrated to local facility availability so 65%+ diversion is realistic, not theoretical.",
    },
  ],
  painPoints: [
    "Submitting an SF ADU plan without DBI portal reference — auto-rejection.",
    "Missing Berkeley / Oakland's 75%+ diversion bumps — fail at first review.",
    "Wrong hauler/facility for the East Bay vs. Peninsula — flagged as 'not on approved list'.",
    "Forgetting the embodied-carbon line in Marin submittals.",
    "No subcontractor acknowledgement on Santa Clara packages.",
  ],
  faqs: [
    {
      q: "Which Bay Area counties does this cover?",
      a: "All nine: San Francisco, Alameda, Contra Costa, Marin, San Mateo, Santa Clara, Solano, Sonoma, and Napa. Each has its own jurisdictional notes that auto-populate when you pick a county in the wizard.",
    },
    {
      q: "Are the local stricter diversion targets supported?",
      a: "Yes. Cities like Berkeley, Oakland, and parts of San Francisco require 75%+ diversion. The wizard adjusts the math and the AI memo references the specific local ordinance.",
    },
    {
      q: "Does the AI memo handle SF DBI vs Marin Planning?",
      a: "Yes — the memo's 'To:' line and call-to-action change based on the project's jurisdiction (SF DBI, Alameda County CDA, Marin Planning, etc.). One submission, the right addressee every time.",
    },
    {
      q: "How much does it cost?",
      a: "A one-off CWMP is $59. Bundle (CWMP + Final Verification + unlimited AI memos) is $89, or unlimited monthly subscriptions are available for high-volume contractors. Pick the tier that fits your project volume.",
    },
  ],
};

const CountyBayAreaPage = () => <CountyLandingPage data={data} />;
export default CountyBayAreaPage;
